import axios from 'axios';
import cookie from '../cookieHelper/cookie'; 

export default function getStoriesByCompanyID(companyId) {
    const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/storyList?companyId=${companyId}&mediaType=mp4`;

    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    return (
        axios.get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            }
        })
        .then(res => {
            // console.log('resstories: ', res);
            return res.data.data[0].stories;
        })
        .catch(err => {
            // console.error('Error fetching stories: ', err);
            return err;
        })
    );
}
